import Splide from '@splidejs/splide';

export default class SplideSlider {
  constructor() {
    this.slider = document.querySelector('.js-splide');
    if (this.slider) {
      this.init();
    }
  }

  init() {
    const isMobile = window.innerWidth <= 768;

    const options = isMobile
      ? {
          type: 'loop',
          perPage: 1,
          perMove: 1,
          direction: 'ltr',
          arrows: false,
          pagination: true,
          focus: 'center',
          gap: '1rem',
          padding: { left: '10vw', right: '10vw' },
        }
      : {
          // destroy:true
          type: 'slide',
          direction: 'ttb',
          heightRatio: 1.1,
          perPage: 1,
          perMove: 1,
          arrows: false,
          pagination: false,
          gap: '40px',
          drag: true,
          wheel: true,
		  speed:800,
		  easing: 'cubic-bezier(0.22,1,0.36,1)',
		  waitForTransition: true,
		  wheelSleep: 0,
		  wheelMinThreshold: 10,
		  flickPower: 200,
		  releaseWheel: true, 
        };

    this.splide = new Splide(this.slider, options).mount();

    // ttb（デスクトップ側）のみ、ページスクロール受け渡しを有効化
    if (!isMobile && options.direction === 'ttb') {
      this.enableScrollPassthrough();
    }
  }

  enableScrollPassthrough() {
    const onWheel = (e) => {
      // Splide の現在位置と境界
      const idx = this.splide.index;
      const lastIndex = this.splide.length - 1; // 総スライド数 - 1
      const atLast = idx >= lastIndex;
      const atFirst = idx <= 0;

      // 下方向: 最終スライドでさらに下へ → ページへ渡す
      if (e.deltaY > 0 && atLast) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        return;
      }

      // 上方向: 最初のスライドでさらに上へ → ページへ渡す
      if (e.deltaY < 0 && atFirst) {
        e.stopPropagation();
        e.stopImmediatePropagation();
        return;
      }

      // それ以外（中間スライド）は Splide に任せる
    };

    // Splide より先にフックし、preventDefault 可能にする
    this._onWheel = onWheel;
    this.slider.addEventListener('wheel', this._onWheel, { capture: true, passive: false });
  }

  // 破棄が必要な場合に備えて公開
  destroy() {
    if (this._onWheel) {
      this.slider.removeEventListener('wheel', this._onWheel, { capture: true });
    }
    this.splide?.destroy(true);
    this.splide = null;
  }
}
